import { useEffect, useState, type ReactNode } from 'react';
import { IntlProvider } from 'react-intl';

import { useAppDispatch, useAppSelector } from '../redux-utils';

import intlSelectors from './intlSelectors';
import { initLocale } from './intlSlice';

function LocaleProvider({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();
  const [isInitialized, setIsInitialized] = useState(false);

  const { locale, messages, providerLocale } = useAppSelector(intlSelectors);

  useEffect(() => {
    dispatch(initLocale());
    setIsInitialized(true);
  }, [dispatch]);

  if (!isInitialized) return null;

  return (
    <IntlProvider locale={providerLocale} messages={messages}>
      <div key={locale} style={{ height: '100%' }}>
        {children}
      </div>
    </IntlProvider>
  );
}

export default LocaleProvider;
